import React from "react";
import { HTMLProps, PropsWithChildren } from "react";

const ContentWrapper: React.FunctionComponent<
  PropsWithChildren<HTMLProps<HTMLDivElement>>
> = ({ children, ...rest }) => {
  return (
    <div className="px-4 lg:px-20 xl:px-[141px]" {...rest}>
      {children}
    </div>
  );
};

export default ContentWrapper;
